"use client";

import React, { useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';


const TopMenu = () => {
	const [isOpen, setIsOpen] = useState(false);

	const handleMenuToggle = () => {
		setIsOpen(prev => !prev);
	};

	return (
		<>
			<div className="fixed w-full px-4 flex items-center justify-between h-[72px] bg-white z-20 dark:bg-dark-700">
				<div className="flex items-center space-x-8 h-full">
					<div className="flex items-center space-x-5">
						<div className="md:hidden flex items-center z-20">
							<button onClick={handleMenuToggle} aria-label="Menu" className=''>
								<FontAwesomeIcon icon={isOpen ? faTimes : faBars} height={20} width={20} />
							</button>
						</div>
						<Link href="/">
							<div>
								<Image
									src="/images/Group1428.png"
									alt="Logo Light Mode"
									className="dark:hidden" // Hide in dark mode
									width={130}
									height={20}
									priority
								/>
								<Image
									src="/images/Group1427.png"
									alt="Logo Dark Mode"
									className="hidden dark:block" // Show only in dark mode
									width={130}
									height={20}
									priority
								/>
							</div>
						</Link>
						<div className="hidden md:flex items-center space-x-8 text-sm ps-10">
						<Link href="/myeducation"><button className='font-bold text-slate-500 hover:text-purple-500 dark:text-white hover:dark:text-purple-100'>myEducation</button></Link>
						<Link href="/myjob"><button className='font-bold text-slate-500 hover:text-purple-500 dark:text-white hover:dark:text-purple-100'>myJob</button></Link>
							<Link href="/mydesk"><button className='font-bold text-slate-500 hover:text-purple-500 dark:text-white hover:dark:text-purple-100'>myDesk</button></Link>
							<Link href="/mycast"><button className='font-bold text-slate-500 hover:text-purple-500 dark:text-white hover:dark:text-purple-100'>myCast</button></Link>
						</div>
					</div>
				</div>


			</div>
			<div
				className={`md:hidden fixed inset-0 bg-white dark:bg-gray-800 z-10 transition-transform transform ${isOpen ? 'translate-y-0' : '-translate-y-full'}`}
			>
				<div className="flex flex-col items-center justify-center h-full">
					<Link href="/myeducation">
						<div className=" text-2xl font-bold mb-4 cursor-pointer">myEducation</div>
					</Link>
					<Link href="/myjob">
						<div className=" text-2xl font-bold mb-4 cursor-pointer">myJob</div>
					</Link>
					<Link href="/mydesk">
						<div className=" text-2xl font-bold mb-4 cursor-pointer z-30">myDesk</div>
					</Link>
					<Link href="/mycast">
						<div className=" text-2xl font-bold mb-4 cursor-pointer">myCast</div>
					</Link>
				</div>
			</div>
		</>
	);
};

export default TopMenu;